// @ts-nocheck
import { toDateInputValue } from './orderStatus.helpers';

// Default period: from the first of the current month until today.
export const getDefaultPeriod = (today = new Date()) => ({
    from: toDateInputValue(new Date(today.getFullYear(), today.getMonth(), 1)),
    to: toDateInputValue(today),
});

// Turns the page filters into API params. Dates cover whole local days.
export const buildStatisticsParams = ({ from, to, advisorId, productId, status }) => {
    const params = {
        from: from ? new Date(`${from}T00:00:00`).toISOString() : undefined,
        to: to ? new Date(`${to}T23:59:59.999`).toISOString() : undefined,
        advisorId: advisorId || undefined,
        productId: productId || undefined,
        status: status || undefined,
    };
    return Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined));
};

export const formatPercent = (part, total) => (total ? `${Math.round((part / total) * 100)} %` : '0 %');

// Rows for a bar list: every known option in its order, plus any other values found in the data.
export const toBarRows = (counts = {}, options = []) => {
    const known = options.map(option => ({ key: option.value, label: option.name, count: counts[option.value] || 0 }));
    const other = Object.entries(counts)
        .filter(([key]) => !options.some(option => option.value === key))
        .map(([key, count]) => ({ key, label: key, count }));
    return [...known, ...other];
};
